import React, { Component, Fragment } from "react";
import DeleteModel from "./DeleteModel";
import AppContext from "../../../contexts/AppContext";
import { Link } from "react-router-dom";
import ApplicantModal from "./ApplicantModal";

class List extends Component {
    state = {
        delete: false,
        item: {},
        showApplicantModal: false
    };

    delete = () => {
        return this.props.delete(this.props.item.id);
    };
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    toggleApplicantModal = () => {
        this.setState({ showApplicantModal: !this.state.showApplicantModal });
    };

    render() {
        return (
            <Fragment>
                {this.state.showApplicantModal ? (
                    <ApplicantModal
                        history={this.props.history}
                        toggleApplicantModal={this.toggleApplicantModal}
                        item={this.props.item}
                    ></ApplicantModal>
                ) : null}

                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        <Link
                            to={`/employer/jobListing/workSpace/${this.props.item.link}`}
                        >
                            {this.props.item.title}
                        </Link>
                    </td>
                    <td className="large" onClick={this.toggleApplicantModal}>
                        {this.props.item.applicants}
                    </td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                    <td>{this.props.item.state}</td>
                    <td className="text-right">
                        <Link
                            to={`/jobs/${this.props.item.id}/${this.props.item.title.replace(/\s+/g, '-')}-at-${this.props.item.user.name.replace(/\s+/g, '-')}`}
                            // to={`/jobs/job/${this.props.item.id}/${this.props.item.link}`}
                            target="_blank"
                            className="btn btn-info btn-sm"
                        >
                            View
                        </Link>
                        {this.props.item.state === "active" ||
                        this.props.item.state === "saved" ? (
                            <Link
                                to={`/employer/jobListing/update/${this.props.item.id}`}
                                onClick={this.toggleUpdate}
                                className="btn btn-success btn-sm  ml-2"
                            >
                                Edit
                            </Link>
                        ) : null}

                        <button
                            onClick={this.toggleApplicantModal}
                            type="button"
                            className="btn btn-info btn-sm ml-2"
                        >
                            Applicants
                        </button>

                        <button
                            onClick={this.toggleDelete}
                            type="button"
                            className="btn btn-danger btn-sm ml-2"
                        >
                            Delete
                        </button>
                    </td>
                </tr>
                {this.state.delete === true ? (
                    <DeleteModel
                        delete={this.delete}
                        hideDelete={this.toggleDelete}
                    ></DeleteModel>
                ) : null}
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/employer/jobListing/List.js